import { styled, SvgIcon } from "@mui/material";
import React, { memo } from "react";

export const IndeterminateCheckboxIcon = memo(() => (
  <CheckboxIconStyled className="MuiCheckbox--default">
    <path d="M19,14H5V11H19V14Z" />
  </CheckboxIconStyled>
));
IndeterminateCheckboxIcon.displayName = "IndeterminateCheckboxIcon";

export const CheckedCheckboxIcon = memo(() => (
  <CheckboxIconStyled className="MuiCheckbox--default" viewBox="0 0 16 16">
    <path d="m 6.3957343,11.937732 c -0.11093,0 -0.22213,-0.0224 -0.3336,-0.0672 -0.11093,-0.04427 -0.21626,-0.11653 -0.316,-0.2168 l -2.816798,-2.816 c -0.178133,-0.17813 -0.264267,-0.3976 -0.2584,-0.6584 0.00533,-0.26133 0.097067,-0.4808 0.2752,-0.6584 0.177598,-0.17813 0.397068,-0.2672 0.658398,-0.2672 0.2608,0 0.48,0.08907 0.6576,0.2672 l 2.1672,2.1664 5.3495997,-5.3496 c 0.17814,-0.178133 0.39201,-0.2698662 0.64161,-0.2751995 0.2501,-0.00587 0.464,0.085867 0.6416,0.2751995 0.1781,0.1776 0.2672,0.394134 0.2672,0.6496 0,0.25547 -0.0891,0.47227 -0.2672,0.6504 l -6.0160097,6.016 c -0.10026,0.10027 -0.20586,0.17253 -0.3168,0.2168 -0.11093,0.0448 -0.22213,0.0672 -0.3336,0.0672 z" />
  </CheckboxIconStyled>
));
CheckedCheckboxIcon.displayName = "CheckedCheckboxIcon";

export const CheckboxIcon = memo(() => (
  <CheckboxIconStyledBase className="MuiCheckbox--default" viewBox="0 0 16 16">
    <path d="" />
  </CheckboxIconStyledBase>
));
CheckboxIcon.displayName = "CheckboxIcon";

const CheckboxIconStyled = styled(SvgIcon)(({ theme }) => ({
  border: "none",
  borderRadius: "6px",
  width: "20px",
  height: "20px",
  padding: "2px",
  fontSize: "1rem",
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.getContrastText(theme.palette.primary.main),
}));

const CheckboxIconStyledBase = styled(SvgIcon)(({ theme }) => ({
  borderWidth: "1px",
  borderStyle: "solid",
  borderRadius: "6px",
  width: "20px",
  height: "20px",
  padding: "1px",
  fontSize: "1rem",
  backgroundColor: theme.palette.common.white,
  borderColor: theme.palette.grey[500],
}));
